export const DiamondIcon = () => (
  <svg width="40" height="40" viewBox="0 0 100 100">
    <polygon
      points="50,10 90,50 50,90 10,50"
      fill="#fff"
      stroke="#333"
      strokeWidth="2"
    />
  </svg>
);
